import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ClientServiceService } from '../services/client-service.service';
import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { LangService } from '../services/lang.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  auth_client_token: any = null;
  dashboard: any = null;
  @Input() dashboard_email: string = "";
  @Output() rerender = new EventEmitter<void>();

  all_brokers: any = [];
  completed_brokers: any = [];
  in_progress_brokers: any = [];
  progress_percentage: number = 0;

  timelines: any = [];

  defaultLogo = "assets/img/round_corners.png";

  constructor(
    private client_service: ClientServiceService,
    private router: Router,
    private langService: LangService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.auth_client_token = localStorage.getItem("auth_client_token");
    if (!this.auth_client_token) {
      this.router.navigate(["/login"]);
    }
    this.get_dashboard();
  }

  get_translated_timeline(text: string) {
    return this.translate.instant(`timelines.${text}`);
  }

  get_dashboard() {
    this.client_service.get_dashboard(this.auth_client_token, this.dashboard_email).subscribe({
      next: (data) => {
        this.get_timelines();
        this.dashboard = data;
        this.all_brokers = data.brokers.all;
        this.completed_brokers = data.brokers.completed;
        this.in_progress_brokers = data.brokers.in_progress;
        this.progress_percentage = Math.round(data.progress_percentage);
      },
      error: (err) => {
        if(err.status === 404) {
          this.client_service.set_is_form_visible(true);
          this.router.navigate(["/dashboard"]);
          this.rerender.emit();
        }
        if(err.status === 403) {
          window.location.href = "/dashboard"
        }
      }
    })
  }

  getFormattedDate(date: string | Date | null): string {
    if (!date) return '-';
  
    const lang = this.langService.currentLang;

    const formatMap: Record<string, string> = {
      en: 'MMM d, yyyy',
      de: 'd. MMM yyyy',
      ja: 'yyyy年M月d日'
    };
  
    const format = formatMap[lang] || formatMap['en'];
  
    return formatDate(date, format, 'en-US');
  }

  get_timelines() {
    this.client_service.get_timelines(this.auth_client_token, this.dashboard_email).subscribe({
      next: (data) => {
        this.timelines = data;
      },
      error: (err) => {
        // console.log(err);
      }
    })
  }

  handleImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = this.defaultLogo;
  }
}
